import React, { useState } from 'react'
import { Stack, TableContainer, Table, Thead, Tr, Th, Tbody, Td, IconButton, Select, Text } from '@chakra-ui/react'

import { FaArrowLeft, FaArrowRight } from 'react-icons/fa'

export default function History() {
    const [details] = useState([
        {
          invoiceReference: "17656",
          invoiceDate: "26-Dec-2022 12:43:22",
          businessName: "Ace Accountantss",
          invoices: "0",
          invoiceCredits: "0",
          bankStatementsProcessed: "8",
          bankStatementsCredits: "24",
          otherDocumentProcessed: "0",
          otherDocumentCredits: "0",
          totalCredits: "24",
        },
        {
          invoiceReference: "17657",
          invoiceDate: "26-Dec-2022 12:43:22",
          businessName: "Ace Accountantss",
          invoices: "0",
          invoiceCredits: "0",
          bankStatementsProcessed: "8",
          bankStatementsCredits: "24",
          otherDocumentProcessed: "0",
          otherDocumentCredits: "0",
          totalCredits: "24",
        },
        {
          invoiceReference: "17658",
          invoiceDate: "26-Dec-2022 12:43:22",
          businessName: "Ace Accountantss",
          invoices: "0",
          invoiceCredits: "0",
          bankStatementsProcessed: "8",
          bankStatementsCredits: "24",
          otherDocumentProcessed: "0",
          otherDocumentCredits: "0",
          totalCredits: "24",
        },
        {
          invoiceReference: "17659",
          invoiceDate: "26-Dec-2022 12:43:22",
          businessName: "Ace Accountantss",
          invoices: "0",
          invoiceCredits: "0",
          bankStatementsProcessed: "8",
          bankStatementsCredits: "24",
          otherDocumentProcessed: "0",
          otherDocumentCredits: "0",
          totalCredits: "24",
        }
      ]
      );
    return (
        <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
            <TableContainer h={'sm'} overflowY={'scroll'}>
                <Table size='sm'>
                    <Thead position={'sticky'} top={'0%'} zIndex={1} h={'50px'} bg={'primary.400'} alignItems={'flex-start'}>
                        <Tr>
                            <Th isNumeric
                                color={'white'}
                            >
                                Invoice Reference
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Invoice Date
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Business Name
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Invoices
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Invoice Credits
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Bank Statements Processed
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Bank Statements Credits
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Other Document Processed
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Other Document Credits
                            </Th>
                            <Th
                                color={'white'}
                            >
                                Total Credits
                            </Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {
                            details.map(row => (
                                <Tr>
                                    <Td textAlign={'center'}>{row.invoiceReference}</Td>
                                    <Td>{row.invoiceDate}</Td>
                                    <Td>{row.businessName}</Td>
                                    <Td isNumeric>{row.invoices}</Td>
                                    <Td isNumeric>{row.invoiceCredits}</Td>
                                    <Td isNumeric>{row.bankStatementsProcessed}</Td>
                                    <Td isNumeric>{row.bankStatementsCredits}</Td>
                                    <Td isNumeric>{row.otherDocumentProcessed}</Td>
                                    <Td isNumeric>{row.otherDocumentCredits}</Td>
                                    <Td isNumeric>{row.totalCredits}</Td>
                                </Tr>
                            ))
                        }
                    </Tbody>
                </Table>
            </TableContainer>
            <Stack
                direction={'row'}
                justify={"space-between"}
                align={'center'}
            >
                <Text>Showing 5 of 10 results</Text>
                <Stack direction={'row'} spacing={4}>
                    <Select placeholder="Select Rows Per Page">
                        <option selected>5 Per Page</option>
                        <option>10 Per Page</option>
                        <option>25 Per Page</option>
                        <option>50 Per Page</option>
                    </Select>
                    <Stack direction={'row'}>
                        <IconButton
                            aria-label="Previous"
                            icon={<FaArrowLeft />}
                            rounded={'full'}
                        />
                        <IconButton
                            aria-label="Previous"
                            icon={<FaArrowRight />}
                            rounded={'full'}
                        />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}